import type { PageContext } from '@zto/zpage-runtime'
import { uuid } from '@zto/zpage'
import { SysConfigPaths } from '@/config'
import { getTdlNumber } from '@/utils'

export function roomDictDialog(isEdit: boolean) {
  return {
    width: 420,
    labelWidth: 110,
    itemSpan: 24,
    title: isEdit ? '编辑户型号' : '添加户型号',
    formItems: [
      {
        type: 'input',
        prop: 'name',
        label: '房间号',
        required: true,
        trim: true,
        maxlength: 6
      },
      // {
      //   type: 'input',
      //   prop: 'tdlNumber',
      //   label: '房间号编号',
      //   required: true,
      //   trim: true,
      //   maxlength: 10,
      //   visibleOn: `${isEdit}` // 编辑时 显示
      // },
    ],
    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) {
        return {
          payload: {
            name: undefined
          }
        }
      }
      return {
        payload: {
          ...data,
        }
      }
    },
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      console.info('🚀 ~ file:_dialogs method:beforeSubmit line:41 ----- beforeSubmit')
      const { tdlNumber, name, ...other} = data || {}
      if(!isEdit){
        return {
          parentNodePath: SysConfigPaths.ROOM_DICT,
          code: uuid(),
          name,
          // sort: 1,
          status: 1, // 1:启用 0:禁用
          // data: {
          //   tdlNumber: getTdlNumber(name)
          // }
        }
      }
      return {
        ...other,
        name,
        // data: {
        //   tdlNumber
        // }
      }
    },

    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
